export type NavLink = {
    label: string
    href: string
    description?: string
}

export type NavColumn = {
    label: string
    href?: string
    children?: NavLink[]
}

export type NavItem = {
    label: string
    href?: string
    columns?: NavColumn[]
    children?: NavLink[]
    mega?: boolean
}

export const mainNav: NavItem[] = [
    {
        label: 'Shop Rates',
        href: '/',
    },
    {
        label: 'About',
        href: '/about',
    },
    {
        label: 'FAQ',
        href: '/faq',
    },
    {
        label: 'Contact Us',
        href: '/contact',
    },
]
